import axios from 'axios';
import React, { useState, useEffect } from 'react'
import Main from '../Main'
import background from '../assets/img/pexels-engin-akyurt-1435752.jpg'
import BackToService from './BackToService';


function Faker() {

    const [fakeData, setFakeData] = useState({});

    const fetchDetails = async () => {
        const { data } = await axios.get('https://randomuser.me/api/');
        //setFakeData(response);
        const details = data.results[0];
        setFakeData(details);
    }

    useEffect(() => {
        fetchDetails();
    }, []);


    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Faker <BackToService /></h2>
                            <div className="row" style={{ "marginTop": "30px" }}>
                                <div className="col-md-12" style={{ "position": "relative" }}>
                                    <i className="bx bx-refresh link-label" onClick={fetchDetails}></i>
                                    <img src={background} alt="" style={{ "width": "100%", "height": "250px" }} />
                                </div>
                            </div>
                            <div className="row user-card">
                                <div className="col-md-12" style={{ "textAlign": "center", "position": "relative", "top": "-70px" }}>
                                    <img src={fakeData.picture ? fakeData.picture.large : ""} alt="" className="img-fluid rounded-circle" style={{ "border": "8px solid lightgray" }} />
                                    <h4 style={{ "color": "gray", "marginTop": "20px" }}>Hello! My name is</h4>
                                    <h3>{fakeData.name ? fakeData.name.title + " " + fakeData.name.first + " " + fakeData.name.last : ""}</h3>
                                </div>
                                <div className="col-md-6 row user-card-details">
                                    <div className="col-md-12"><h5 style={{ "fontSize": "25px", "color": "#6987af", "textAlign": "center" }}>Basic Details</h5></div>
                                    <div className="col-md-3"><strong sty>Gender</strong></div><div className="col-md-9">{fakeData ? fakeData.gender : ""}</div>
                                    <div className="col-md-3"><strong>Age  </strong></div><div className="col-md-9">{fakeData.dob ? fakeData.dob.age : ""}</div>
                                    <div className="col-md-3"><strong>Phone  </strong></div><div className="col-md-9">{fakeData ? fakeData.phone : ""}</div>
                                    <div className="col-md-3"><strong>Email  </strong></div><div className="col-md-9">{fakeData ? fakeData.email : ""}</div>
                                    <div className="col-md-3"><strong>D-O-B </strong></div><div className="col-md-9">{fakeData.dob ? fakeData.dob.date : ""}</div>
                                    <div className="col-md-3"><strong>Street  </strong></div><div className="col-md-9">{fakeData.location ? fakeData.location.street.name : ""}</div>
                                    <div className="col-md-3"><strong>City  </strong></div><div className="col-md-9">{fakeData.location ? fakeData.location.city : ""}</div>
                                    <div className="col-md-3"><strong>State  </strong></div><div className="col-md-9">{fakeData.location ? fakeData.location.state : ""}</div>
                                    <div className="col-md-3"><strong>Post Code  </strong></div><div className="col-md-9">{fakeData.location ? fakeData.location.postcode : ""}</div>
                                </div>
                                <div className="col-md-6 row user-card-details">
                                    <div className="col-md-12"><h5 style={{ "fontSize": "25px", "color": "#6987af", "textAlign": "center" }}>Login Details</h5></div>
                                    <div className="col-md-3"><strong sty>uuid</strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.uuid : ""}</div>
                                    <div className="col-md-3"><strong>Username  </strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.username : ""}</div>
                                    <div className="col-md-3"><strong>Password  </strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.password : ""}</div>
                                    <div className="col-md-3"><strong>Salt  </strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.salt : ""}</div>
                                    <div className="col-md-3"><strong>Md5 </strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.md5 : ""}</div>
                                    <div className="col-md-3"><strong>Sha1  </strong></div><div className="col-md-9">{fakeData.login ? fakeData.login.sha1 : ""}</div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Main>
        </>

    )
}

export default Faker
